/**
 * Timing Constants
 * 
 * Centralized timing values for consistent behavior across the application.
 * These values are business logic related, not UI animation timing.
 */

export const TIMING = {
  /**
   * Polling intervals for real-time updates
   */
  POLLING: {
    /** Poll interval for venue enrichment status updates (3 seconds) */
    VENUE_ENRICHMENT: 3000,
    /** Poll interval for job status updates (5 seconds) */
    JOB_STATUS: 5000,
    /** Poll interval for general data refresh (10 seconds) */
    DATA_REFRESH: 10000,
  },

  /**
   * Timeout thresholds for detecting stuck/stale processes
   */
  TIMEOUTS: {
    /** Time after which a venue enrichment is considered stuck (2 minutes) */
    VENUE_ENRICHMENT_STUCK: 2 * 60 * 1000,
    /** Time after which a background job is considered stuck (5 minutes) */
    JOB_STUCK: 5 * 60 * 1000,
  },

  /**
   * Debounce delays for user input
   */
  DEBOUNCE: {
    /** Search input debounce (300ms) */
    SEARCH: 300,
    /** Filter input debounce (500ms) */
    FILTER: 500,
    /** Auto-save debounce (1 second) */
    AUTO_SAVE: 1000,
  },

  /**
   * Delay before retrying operations
   */
  RETRY: {
    /** Short retry delay (1 second) */
    SHORT: 1000,
    /** Medium retry delay (3 seconds) */
    MEDIUM: 3000,
    /** Long retry delay (5 seconds) */
    LONG: 5000,
  },
} as const;

export type TimingConfig = typeof TIMING;

